<div class="chart-container">
  <canvas id="AreaChart">{{ chart }}</canvas>
</div>
